/* Step 11c-3 · find 35 (Mars Live Run Log) — "Send to misstatements" on a related-party exception row asks, on send, for
   the misstatement TYPE (Factual / Judgmental / Disclosure) and the EXCEPTION's amount (prefilled with what the row last
   sent; a Disclosure item has no amount — 0 is sent). Before, the row's whole-year transaction amount went to W9 as Factual
   (5,710,320.28 on Mars). The server checks both (backend/rp_exception_send.py). */
import React, { useState } from "react";
import { Button } from "@/components/ui/button";

const TYPES = ["Factual", "Judgmental", "Disclosure"];

export default function RpSendException({ row, onSend, t, testid }) {
  const [open, setOpen] = useState(false);
  const [mtype, setMtype] = useState(row?.exception_type || "");
  const [amount, setAmount] = useState(row?.exception_amount != null ? String(row.exception_amount) : "");
  const [busy, setBusy] = useState(false);
  const isDisc = mtype === "Disclosure";
  const amt = Number(String(amount).replace(/,/g, ""));
  const ok = mtype && (isDisc || (amount !== "" && Number.isFinite(amt) && Math.abs(amt) >= 0.01));
  const go = async () => {
    setBusy(true);
    try { if (await onSend({ mtype, amount: isDisc ? 0 : amt })) setOpen(false); } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={testid}>{t("rp.sendToMisstatements")}</Button>
    );
  }
  return (
    <div className="mt-1 inline-flex flex-wrap items-center gap-1 rounded border border-amber-300 bg-amber-50 p-1 text-[11px] dark:border-amber-900 dark:bg-amber-950/30"
         data-testid={`${testid}-form`}>
      <label className="inline-flex items-center gap-1">{t("s11c3Rp.type")}
        <select className="h-6 text-[11px]" value={mtype} onChange={(e) => setMtype(e.target.value)} data-testid={`${testid}-type`}>
          <option value="">—</option>
          {TYPES.map((x) => <option key={x} value={x}>{t(`s11c3Rp.types.${x}`)}</option>)}
        </select>
      </label>
      <label className="inline-flex items-center gap-1">{t("s11c3Rp.amount")}
        <input className="h-6 w-28 rounded border px-1 text-end" dir="ltr" inputMode="decimal" disabled={isDisc}
               value={isDisc ? "0" : amount} onChange={(e) => setAmount(e.target.value)} data-testid={`${testid}-amount`} />
      </label>
      {isDisc && <span className="text-muted-foreground" data-testid={`${testid}-disc-note`}>{t("s11c3Rp.disclosureNote")}</span>}
      <Button size="sm" disabled={!ok || busy} onClick={go} data-testid={`${testid}-confirm`}>{t("s11c3Rp.send")}</Button>
      <Button size="sm" variant="ghost" disabled={busy} onClick={() => setOpen(false)} data-testid={`${testid}-cancel`}>{t("s11c3Rp.cancel")}</Button>
      {!isDisc && <div className="basis-full text-muted-foreground">{t("s11c3Rp.amountHint")}</div>}
    </div>
  );
}
